import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Sparkles, Calendar, Utensils, ShoppingCart, CheckSquare, Users } from "lucide-react";

import { useAuth } from "../../context/AuthContext";

const HeroSection = () => {
  const auth = useAuth();

  return (
    <div className="bg-light py-5" style={{ minHeight: "90vh" }}>
      <div className="container text-center d-flex flex-column align-items-center justify-content-center">
        <button className="btn btn-outline-primary px-3 py-1 d-flex align-items-center gap-2 mb-4 rounded-pill">
          <Sparkles size={18} /> Mit KI-Unterstützung
        </button>

        <h1 className="fw-bold display-4">
          Dein Familienalltag – <span className="text-primary">entspannt organisiert</span>
        </h1>

        <p className="text-secondary mt-3 fs-5" style={{ maxWidth: "700px" }}>
          Plane eure Woche gemeinsam: Termine, Mahlzeiten, Einkäufe und To-dos an einem Ort.
          Mit KI-Assistent, der mitdenkt und euch Zeit spart.
        </p>

        <div className="d-flex gap-3 mt-4">
          <button
            className="btn btn-primary btn-lg px-4 rounded-pill"
            onClick={() => auth.login()}
          >
            Kostenlos starten
          </button>
          <a
            href="#features"
            className="btn btn-outline-secondary btn-lg px-4 rounded-pill text-decoration-none d-flex align-items-center"
          >
            Demo ansehen
          </a>
        </div>

        <div className="d-flex gap-3 mt-5 flex-wrap justify-content-center">
          <div className="btn btn-light d-flex align-items-center gap-2 px-3 py-2 rounded-pill shadow-sm">
            <Calendar size={18} /> Wochenplaner
          </div>
          <div className="btn btn-light d-flex align-items-center gap-2 px-3 py-2 rounded-pill shadow-sm">
            <Utensils size={18} /> Essensplan
          </div>
          <div className="btn btn-light d-flex align-items-center gap-2 px-3 py-2 rounded-pill shadow-sm">
            <ShoppingCart size={18} /> Einkaufsliste
          </div>
          <div className="btn btn-light d-flex align-items-center gap-2 px-3 py-2 rounded-pill shadow-sm">
            <CheckSquare size={18} /> Checklisten
          </div>
          <div className="btn btn-light d-flex align-items-center gap-2 px-3 py-2 rounded-pill shadow-sm">
            <Users size={18} /> Familien-Sharing
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
